/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NatRegistration } from '../models/NatRegistration';
import type { NatRegistrationCreateAdmin } from '../models/NatRegistrationCreateAdmin';
import type { NatRegistrationUpdate } from '../models/NatRegistrationUpdate';
import type { OwnRegistrationCreate } from '../models/OwnRegistrationCreate';
import type { OwnRegistrationRenew } from '../models/OwnRegistrationRenew';
import type { OwnRegistrationRenewChangeIP } from '../models/OwnRegistrationRenewChangeIP';
import type { OwnRegistrationUpdate } from '../models/OwnRegistrationUpdate';
import type { PersonalRegistration } from '../models/PersonalRegistration';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MyRegistrationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Remaining
     * @param ip
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public remainingMyRegistrationsRemainingGet(
        ip?: string,
        authorization?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/my-registrations/remaining',
            headers: {
                'authorization': authorization,
            },
            query: {
                'ip': ip,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List
     * @param authorization
     * @returns PersonalRegistration Successful Response
     * @throws ApiError
     */
    public listMyRegistrationsGet(
        authorization?: string,
    ): CancelablePromise<Array<PersonalRegistration>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/my-registrations/',
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create
     * @param requestBody
     * @param authorization
     * @returns PersonalRegistration Successful Response
     * @throws ApiError
     */
    public createMyRegistrationsPost(
        requestBody: OwnRegistrationCreate,
        authorization?: string,
    ): CancelablePromise<PersonalRegistration> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/my-registrations/',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Nat
     * @param authorization
     * @returns NatRegistration Successful Response
     * @throws ApiError
     */
    public listNatMyRegistrationsNatGet(
        authorization?: string,
    ): CancelablePromise<Array<NatRegistration>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/my-registrations/nat/',
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get
     * @param uuid
     * @param authorization
     * @returns PersonalRegistration Successful Response
     * @throws ApiError
     */
    public getMyRegistrationsUuidGet(
        uuid: string,
        authorization?: string,
    ): CancelablePromise<PersonalRegistration> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/my-registrations/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update
     * @param uuid
     * @param requestBody
     * @param authorization
     * @returns PersonalRegistration Successful Response
     * @throws ApiError
     */
    public updateMyRegistrationsUuidPut(
        uuid: string,
        requestBody: OwnRegistrationUpdate,
        authorization?: string,
    ): CancelablePromise<PersonalRegistration> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/my-registrations/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete
     * @param uuid
     * @param authorization
     * @returns void
     * @throws ApiError
     */
    public deleteMyRegistrationsUuidDelete(
        uuid: string,
        authorization?: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/my-registrations/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Nat
     * @param uuid
     * @param authorization
     * @returns NatRegistration Successful Response
     * @throws ApiError
     */
    public getNatMyRegistrationsNatUuidGet(
        uuid: string,
        authorization?: string,
    ): CancelablePromise<NatRegistration> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/my-registrations/nat/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Nat
     * @param uuid
     * @param requestBody
     * @param authorization
     * @returns NatRegistration Successful Response
     * @throws ApiError
     */
    public updateNatMyRegistrationsNatUuidPut(
        uuid: string,
        requestBody: NatRegistrationUpdate,
        authorization?: string,
    ): CancelablePromise<NatRegistration> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/my-registrations/nat/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Nat
     * @param uuid
     * @param authorization
     * @returns void
     * @throws ApiError
     */
    public deleteNatMyRegistrationsNatUuidDelete(
        uuid: string,
        authorization?: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/my-registrations/nat/{uuid}',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Nat
     * @param requestBody
     * @param authorization
     * @returns NatRegistration Successful Response
     * @throws ApiError
     */
    public createNatMyRegistrationsNatPost(
        requestBody: NatRegistrationCreateAdmin,
        authorization?: string,
    ): CancelablePromise<NatRegistration> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/my-registrations/nat',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Renew
     * @param uuid
     * @param requestBody
     * @param authorization
     * @returns PersonalRegistration Successful Response
     * @throws ApiError
     */
    public renewMyRegistrationsUuidRenewPost(
        uuid: string,
        requestBody: OwnRegistrationRenew,
        authorization?: string,
    ): CancelablePromise<PersonalRegistration> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/my-registrations/{uuid}/renew',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Renew Change Ip
     * @param uuid
     * @param requestBody
     * @param authorization
     * @returns PersonalRegistration Successful Response
     * @throws ApiError
     */
    public renewChangeIpMyRegistrationsUuidRenewChangeIpPost(
        uuid: string,
        requestBody: OwnRegistrationRenewChangeIP,
        authorization?: string,
    ): CancelablePromise<PersonalRegistration> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/my-registrations/{uuid}/renew-change-ip',
            path: {
                'uuid': uuid,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
